import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import costCenterDataService from "../../services/costCenter.service";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const CostCenterList = () => {
    const [costCenters, setCostCenters] = useState([]);
    const [currentCostCenter, setCurrentCostCenter] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [searchCostCenter, setSearchCostCenter] = useState("");
    const [costStats, setCostStats] = useState([]);

    const [chartTitle, setChartTitle] = useState("");
    const [chartData, setChartData] = useState(null);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: chartTitle,
            },
        },
    };

    const handleChartToggle = (e) => {
        console.log(e.target.id);

        switch (e.target.id) {
            case "w":
                setChartTitle("Week view");
                setChartData(costStats.slice(0, 2));
                break;
            case "m":
                setChartTitle("Month view");
                setChartData(costStats.slice(2, 4));
                break;
            case "q":
                setChartTitle("Quarter view");
                setChartData(costStats.slice(4, 6));
                break;
            case "y":
                setChartTitle("Year view");
                setChartData(costStats.slice(6));
                break;
        }
    };

    let navigate = useNavigate();

    useEffect(() => {
        retrieveCostCenters();
    }, []);

    const handleDoubleClick = () => {
        navigate("/costCenters/" + currentCostCenter.id);
    };

    const onChangeSearchCostCenter = (e) => {
        const searchCostCenter = e.target.value;
        setSearchCostCenter(searchCostCenter);
    };

    const retrieveCostCenters = () => {
        costCenterDataService
            .getAll()
            .then((response) => {
                setCostCenters(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const refreshList = () => {
        retrieveCostCenters();
        setCurrentCostCenter(null);
        setCurrentIndex(-1);
    };

    const setActiveCostCenter = (costCenter, index) => {
        setCurrentCostCenter(costCenter);
        setCurrentIndex(index);
        costCenterDataService
            .getCostStats(costCenter.id)
            .then((response) => {
                setChartTitle("Week view");
                setChartData(null);
                if (response.data[0] !== undefined) {
                    let res = Object.values(response.data[0]);
                    setCostStats(res.slice(2));
                    setChartData(res.slice(2, 4));
                } else {
                    setCostStats([0, 0]);
                }
            })
            .catch((e) => {
                console.log(e);
            });
        // console.log(weeklyCosts);
    };

    const removeAllCostCenters = () => {
        costCenterDataService
            .removeAll()
            .then((response) => {
                console.log(response.data);
                refreshList();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const findByName = () => {
        costCenterDataService
            .findByName(searchCostCenter)
            .then((response) => {
                setCostCenters(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <div className="row">
            <nav className="navbar bg-body-tertiary module-nav">
                <div className="container-fluid">
                    <div className="nav-item">
                        <Link
                            to={"/costCenters/add"}
                            state={{ returnTo: "/costCenters" }}
                            className="m-1 btn btn-sm btn-success"
                        >
                            Add
                        </Link>

                        {/* <button
                            className="m-1 btn btn-sm btn-danger"
                            onClick={removeAllCostCenters}
                        >
                            Remove All
                        </button> */}

                        <button
                            className="m-1 btn btn-sm btn-warning"
                            onClick={() => {
                                navigate(
                                    "/costCenters/" + currentCostCenter.id
                                );
                            }}
                            disabled={!currentCostCenter}
                        >
                            Edit
                        </button>
                    </div>

                    <form className="d-flex" role="search">
                        <div className="input-group">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                    searchCostCenter = "";
                                }}
                            >
                                <i className="bi bi-eraser"></i>
                            </button>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Name..."
                                value={searchCostCenter}
                                onChange={onChangeSearchCostCenter}
                            />
                            <button
                                className="btn btn-outline-primary"
                                type="button"
                                onClick={findByName}
                            >
                                Search
                            </button>
                        </div>
                    </form>
                </div>
            </nav>

            <div className="col-md-10 module-table">
                <h4 className="page-title">Cost Centers</h4>

                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {costCenters &&
                            costCenters.map((costCenter, index) => (
                                <tr
                                    className={
                                        index === currentIndex
                                            ? "table-primary"
                                            : ""
                                    }
                                    onClick={() =>
                                        setActiveCostCenter(costCenter, index)
                                    }
                                    onDoubleClick={handleDoubleClick}
                                    key={index}
                                    style={{ userSelect: "none" }}
                                >
                                    <th scope="row">{index + 1}</th>
                                    <td>{costCenter.name}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            <div className="col-md-2 module-detail">
                {currentCostCenter ? (
                    <div className="inner-detail">
                        <h5>Detail</h5>
                        <div>
                            <label>
                                <strong>Name:</strong>
                            </label>{" "}
                            {currentCostCenter.name}
                        </div>
                        <div>
                            <label>
                                <strong>Created at:</strong>
                            </label>{" "}
                            {new Date(
                                currentCostCenter.createdAt
                            ).toDateString()}
                        </div>
                        <div>
                            <label>
                                <strong>Updated at:</strong>
                            </label>{" "}
                            {new Date(
                                currentCostCenter.updatedAt
                            ).toDateString()}
                        </div>
                        <hr></hr>
                        <button
                            className="btn btn-primary me-1 chart-btn"
                            onClick={handleChartToggle}
                            id="w"
                        >
                            W
                        </button>
                        <button
                            className="btn btn-primary me-1 chart-btn"
                            onClick={handleChartToggle}
                            id="m"
                        >
                            M
                        </button>
                        <button
                            className="btn btn-primary me-1 chart-btn"
                            onClick={handleChartToggle}
                            id="q"
                        >
                            Q
                        </button>
                        <button
                            className="btn btn-primary chart-btn"
                            onClick={handleChartToggle}
                            id="y"
                        >
                            Y
                        </button>
                        <div className="chart-container">
                            <Bar
                                options={chartOptions}
                                data={{
                                    labels: ["previous", "current"],
                                    datasets: [
                                        {
                                            label: "Spent (€)",
                                            data: chartData,
                                            borderWidth: 1,
                                            borderColor: [
                                                "rgb(255, 99, 132)",
                                                "rgb(75, 192, 192)",
                                            ],
                                            backgroundColor: [
                                                "rgba(255, 99, 132, 0.2)",
                                                "rgba(75, 192, 192, 0.2)",
                                            ],
                                            hoverBackgroundColor: [
                                                "rgb(255, 99, 132)",
                                                "rgb(75, 192, 192)",
                                            ],
                                        },
                                    ],
                                }}
                                // {...props}
                            />
                        </div>

                        {/* charts carousel */}

                        {/* end of charts carousel */}
                    </div>
                ) : (
                    <div>
                        <p>Please click on a Cost Center...</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CostCenterList;
